export const findAreaCode = phoneNumber => {
  if (typeof phoneNumber !== 'string') {
    return undefined
  }
  const cleanPhoneNumber = phoneNumber.replace(/\D/g, '')
  const regex = /^(\d)?(?<areaCode>\d{3})(\d{7})$/
  const matches = cleanPhoneNumber.match(regex)
  return matches ? matches.groups.areaCode : undefined
}
